var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FsLightbox',{attrs:{"type":"image","toggler":_vm.toggler,"sources":_vm.payload,"source-index":_vm.sourceIndex}})}
var staticRenderFns = []

export { render, staticRenderFns }